<ems-confirm-message #confirmationMessage></ems-confirm-message>

<div class="heading-font sdps-p-bottom_small sdps-display-inline"
     [innerHTML]="getConstant.manageEmployeeGroups.empGroupStep3.reviewAndSave"></div>

<!-- Name, Description and BU section -->
<ems-accordion [label]="getSharedConstant.DBS.nameAndDescription" [editable]="showActionItems"
               [showEditIcon]="showActionItems"
               class="disabled-button-icon" [disabledButton]="true" [toolTip]="true" [message]="toolTipMessage">
  <div class="sdps-p-around_large select-rule-type">
    <form [formGroup]="reviewInstrumentGrpForm">
      <div class="sdps-grid-container sdps-wrap">
        <div class="sdps-row">
          <div class="rule-type-textbox col-3" [ngClass]="{'input-disabled': !showActionItems, 'invalidField': ((reviewInstrumentGrpForm.get('groupName').value && (reviewInstrumentGrpForm.get('groupName').invalid)) || groupNameExists)}">
            <p-floatlabel variant="in">
              <input type="text" name="groupName" [maxlength]="100" formControlName="groupName" id="groupName"
                     #focusName
                     (ngModelChange)="editGroupNameAndDescription()" emsAlphaNumericSpecialCharacterValidation emsCharacterLimit
                     [charMaxLimit]="commonConstants.charLimitValues.hundredMaxLimit"
                     (emsCharacterLimitCheck)="showGroupNameCharLimit = $event" pInputText/>
              <label for="groupName">{{getSharedConstant.DBS.name}}
                <span class="sdps-text-market-red" [innerHTML]="commonConstants.asterix"></span>
              </label>
            </p-floatlabel>
          </div>
          <div class="col-6 sdps-p-left_xx-large sdps-flex">
            <p class="sdps-p-top_medium sdps-p-right_x-small">
              <span [innerHTML]="getConstant.instrumentGroups.instrumentGrpStep1.businessUnit"></span>
              <span class="sdps-text-market-red" [innerHTML]="commonConstants.asterix"></span>
            </p>
            <div class="sdps-p-top_x-small timePickerForm col-4">
              <label class="sr-only" for="businessUnit">{{getConstant.instrumentGroups.instrumentGrpStep1.businessUnit}}</label>
              <p-select inputId="businessUnit" [options]="businessUnitData" placeholder=" " [disabled]="businessUnitData.length === 1"
                          class="timePickerForm editableTimepicker business-unit-dropdown step3-bu" optionLabel="name"
                          formControlName="businessUnit">
              </p-select>
            </div>
          </div>
        </div>
        <p class="col-3 sdps-text-right sdps-p-around_none sdps-m-around_none sdps-text-small"
           *ngIf="reviewInstrumentGrpForm.get('groupName').value && reviewInstrumentGrpForm.get('groupName').value.trim().length > 90">{{getConstant.rulesConstant.characterLimit}}
          <span class="character-limit">{{reviewInstrumentGrpForm.get('groupName').value.trim().length}}
            /{{commonConstants.charLimitValues.hundredMaxLimit}}</span>
        </p>

        <div class="sdps-row sdps-p-top_large">
          <div class="rule-type-textbox sdps-p-around_medium col-6" [ngClass]="{'input-disabled': !showActionItems}">
            <p-floatlabel variant="in">
            <textarea class="sdps-p-vertical_x-small group-desc" rows="5" maxlength="300" formControlName="description" id="description"
            (ngModelChange)="editGroupNameAndDescription()" name="description" emsCharacterLimit (emsCharacterLimitCheck)="showGroupDescCharLimit = $event"
                      [charMaxLimit]="commonConstants.charLimitValues.threeHundredMaxLimit" pTextarea></textarea>
            <label for="description" *ngIf="this.showActionItems">{{getSharedConstant.DBS.description}}</label>
            </p-floatlabel>
          </div>
        </div>
        <p class="col-6 sdps-text-right sdps-p-around_none sdps-m-around_none sdps-text-small"
           *ngIf="reviewInstrumentGrpForm.get('description').value && reviewInstrumentGrpForm.get('description').value.length > 270">{{getConstant.rulesConstant.characterLimit}}
          <span class="character-limit">{{reviewInstrumentGrpForm.get('description').value.length}}
            /{{commonConstants.charLimitValues.threeHundredMaxLimit}}</span>
        </p>
      </div>
 </form>
  </div>
</ems-accordion>
     <!-- Added or Removed security section -->
<ems-accordion *ngIf="addOrRemovedSecurities && addOrRemovedSecurities.length > 0" [editable]="showActionItems"
               [label]="getConstant.instrumentGroups.instrumentGrpStep2.addedOrRemovedInstruments"
               (editPanel)="goToPreviousStep('../step2')" [showEditIcon]="showActionItems">
  <ems-table-record-count [showRecords]="addOrRemovedSecurities && addOrRemovedSecurities.length && addOrRemovedSecurities.length > getSharedConstant.defaultTableRecords" [count]="addOrRemovedSecurities && addOrRemovedSecurities.length" [showHeaderIcons]="false"
                          (emitter)="indTable.reset();receiveDataFromChild($event)"></ems-table-record-count>
  <p-table [columns]="securityTableHeader" [value]="addOrRemovedSecurities" [paginator]="(addOrRemovedSecurities && addOrRemovedSecurities.length && addOrRemovedSecurities.length > getSharedConstant.defaultTableRecords) ? true : false" [rows]="noOfRecords" [totalRecords]="addOrRemovedSecurities && addOrRemovedSecurities.length"
           #indTable
           class="common-data-table">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col" *ngFor="let col of columns">{{col.header}}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-indSec let-columns="columns">
      <tr>
        <td *ngFor="let col of columns">
          <span *ngIf="col.field === 'name'"
                [ngClass]="indSec['selectedSec'] === true ? 'addedEmp' : 'removedEmp'">{{indSec[col.field] | titlecase}}</span>
          <span *ngIf="col.field !== 'name' && col.field !== 'tickerSymbol'"
                [ngClass]="indSec['selectedSec'] === true ? 'addedEmp' : 'removedEmp'">{{indSec[col.field]}}</span>
          <span *ngIf="col.field === 'tickerSymbol'"
                [ngClass]="indSec['selectedSec'] === true ? 'addedEmp' : 'removedEmp'">{{indSec[col.field]}}</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</ems-accordion>

<!-- Selected Securities - Edit flow when no changes is made to securities selection -->
<ems-accordion [label]="getConstant.instrumentGroups.instrumentGrpStep2.selectInstruments" [editable]="showActionItems"
               *ngIf="reviewInstGroupData.mode === 'EDIT' && addOrRemovedSecurities && addOrRemovedSecurities.length === 0"
               (editPanel)="goToPreviousStep('../step2')" [showEditIcon]="showActionItems">
  <ems-table-record-count
    [showRecords]="paginationCount !== 0 ? (paginationCount && paginationCount > getSharedConstant.defaultTableRecords ? true : false) : (selectedSecurities && selectedSecurities.length && selectedSecurities.length > getSharedConstant.defaultTableRecords ? true : false)"
    (emitter)="pageObject.pageNo = 0;pageObject.pageSize = $event;applyFilter()"
    [showHeaderIcons]="true" [groupTotal]="totalSecurities" [count]="totalSecurities"
    [showTotalForSecurities]="totalSecurities"
    [showExportBtn]="!instrumentGrpService.deletedIG && revertDisable && isStep1DetailsUnchanged" (exportClicked)="exportInstrumentGroup()"
    ></ems-table-record-count>
  <p-table [columns]="filterSecurityTableHeader" [value]="selectedSecurities" metaKeySelection="true" #indTable
    [customSort]="true" dataKey="id" sortMode="multiple" [lazy]="true" (onLazyLoad)="customSort($event)"
    [multiSortMeta]="multiSortMeta" [rows]="pageObject.pageSize" class="common-data-table">
    <ng-template #sorticon pTemplate="sorticon" let-sortOrder>
      <span class="pi" [ngClass]="{
                        'pi-sort': sortOrder === 0,
                        'pi-caret-down': sortOrder === -1,
                        'pi-caret-up': sortOrder === 1,
                      }"></span>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <!-- Column header section -->
      <tr class="filter-header-input">
        <th class="table-checkbox-selection filter-icon" aria-label="Filter controls">
          <span class="sr-only">Filter controls</span>
          <button type="button" class="btn-icon-only cursor" (click)="toggleFunction()" aria-label="Toggle filter" [attr.aria-expanded]="toggle">
            <em class="pi pi-filter" aria-hidden="true"></em>
          </button>
        </th>

        <ng-container *ngFor="let col of columns">
          <th *ngIf="col.field !== 'actions'" [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="(col.field==='actions')"
            [ngClass]="[((paginationCount && paginationCount > 1 || filterClicked || selectedSecurities && selectedSecurities.length > 1) ? 'pointer-events-auto' : 'pointer-events-none')]">
            {{col.header}}
            <p-sortIcon [field]="col.field" *ngIf="(col.field !=='actions' && (paginationCount && paginationCount > 1 || filterClicked || selectedSecurities && selectedSecurities.length >1))"></p-sortIcon>
          </th>
          <th *ngIf="col.field === 'actions' && toggle " [ngClass]="'w-200-px'">
            {{col.header}}
          </th>
        </ng-container>
      </tr>

      <!-- Filter row section -->
      <tr *ngIf="toggle" class="filtered-row-input">
        <th aria-label="Filter row"><span class="sr-only">Filter row</span></th>
        <th *ngFor="let col of columns ;let i = index;" class="sdps-p-left_small" [attr.aria-label]="(col.header || 'Column') + ' filter'">
          <form [formGroup]="filterReviewInstrumentGrpForm">
            <label class="sr-only" for="tickerSymbol" *ngIf="col.field === 'tickerSymbol'">{{(col.header || 'Ticker Symbol') + ' filter'}}</label>
            <input id="tickerSymbol" [attr.aria-label]="(col.header || 'Ticker Symbol') + ' filter'" pInputText formControlName="tickerSymbol" class="w-100-per securityFilterListIG" type="text" name="tickerSymbol"
              [maxLength]="100" *ngIf="col.field === 'tickerSymbol'"
              (keydown.enter)="!(invalidTickerSymbol || filterReviewInstrumentGrpForm.invalid) ? applyFilter(): ''" onkeydown="return (event.keyCode !== 13);"
              emsAlphaNumericSpecialCharacterValidation [ngClass]="{'invalidField' : invalidTickerSymbol}">
            <div *ngIf="col.field === 'securityType'"
              class="col-2 emtr-dropdown timePickerForm request-list-filter request-list-multiselect-font-size request-list-filter-multiselect">
              <label class="sr-only" for="securityType">{{(col.header || 'Security Type') + ' filter'}}</label>
              <p-multiSelect inputId="securityType" [attr.aria-label]="(col.header || 'Security Type') + ' filter'" formControlName="securityType"
                [options]="getEmtrConstants.instrumentGroups.instrumentGrpStep3.securityTypeList" [filter]="true" optionLabel="label"
                [defaultLabel]="''" [displaySelectedLabel]="true" [showHeader]="true" [filterPlaceHolder]="'All'"
                [selectedItemsLabel]="'All'" [showToggleAll]="true" [filter]="true">
              </p-multiSelect>
            </div>
            <label class="sr-only" for="name" *ngIf="col.field === 'name'">{{(col.header || 'Name') + ' filter'}}</label>
            <input id="name" [attr.aria-label]="(col.header || 'Name') + ' filter'" pInputText formControlName="name" class="w-100-per" type="text" name="name"
              (keydown.enter)="!(invalidName || filterReviewInstrumentGrpForm.invalid)? applyFilter(): ''" onkeydown="return (event.keyCode !== 13);"
              *ngIf="col.field === 'name'" [ngClass]="{'invalidField' : invalidName }">
            <label class="sr-only" for="cusip" *ngIf="col.field === 'cusip'">{{(col.header || 'CUSIP') + ' filter'}}</label>
            <input id="cusip" [attr.aria-label]="(col.header || 'CUSIP') + ' filter'" pInputText formControlName="cusip" class="w-100-per" type="text" name="cusip"
              (keydown.enter)="!(invalidCusip ||filterReviewInstrumentGrpForm.get('cusip').invalid )? applyFilter(): ''" onkeydown="return (event.keyCode !== 13);"
              *ngIf="col.field === 'cusip'" [maxLength]="9" (input)="onInputChange('cusip', $event)"
              emsAlphaNumericSpecialCharacterValidation [ngClass]="{'invalidField' : invalidCusip || filterReviewInstrumentGrpForm.get('cusip').invalid }">
            <label class="sr-only" for="sedol" *ngIf="col.field === 'sedol'">{{(col.header || 'SEDOL') + ' filter'}}</label>
            <input id="sedol" [attr.aria-label]="(col.header || 'SEDOL') + ' filter'" pInputText formControlName="sedol" class="w-100-per" type="text" name="sedol"
              (keydown.enter)="!(invalidSedol || filterReviewInstrumentGrpForm.get('sedol').invalid)? applyFilter(): ''" onkeydown="return (event.keyCode !== 13);"
              *ngIf="col.field === 'sedol'" [maxLength]="7" (input)="onInputChange('sedol', $event)"
              [ngClass]="{'invalidField' : invalidSedol || filterReviewInstrumentGrpForm.get('sedol').invalid}"
              emsAlphaNumericPatterncheck>
            <label class="sr-only" for="isin" *ngIf="col.field === 'isin'">{{(col.header || 'ISIN') + ' filter'}}</label>
            <input id="isin" [attr.aria-label]="(col.header || 'ISIN') + ' filter'" pInputText formControlName="isin" class="w-100-per" type="text" name="isin"
              (keydown.enter)="!(invalidIsin || filterReviewInstrumentGrpForm.get('isin').invalid)? applyFilter(): ''" onkeydown="return (event.keyCode !== 13);"
              *ngIf="col.field === 'isin'" [maxLength]="12" [ngClass]="{'invalidField' : invalidIsin || filterReviewInstrumentGrpForm.get('isin').invalid}"
              (input)="onInputChange('isin', $event)" emsAlphaNumericPatterncheck>
            <div *ngIf="col.field === 'actions'" class="w-200-px">
              <button id="clearAllButton" class="buttons button-filter" [innerHTML]="getSharedConstant.filterButton.clearAllButton"
                [disabled]="!filterReviewInstrumentGrpForm.dirty && !isSortingChanged"
                (click)="isClickedClearBtn = true; filtersApply ? clickedClearButton(isSortingChanged) : resetForm(isSortingChanged)">
              </button>
              <button id="applyFilterButton" class="buttons button-save button-filter" (click)="applyFilter()"
                [disabled]="invalidTickerSymbol || invalidName || invalidCusip || invalidSedol || invalidIsin || filterReviewInstrumentGrpForm.invalid"
                [innerHTML]="getSharedConstant.filterButton.applyFilterButton"></button>
            </div>
          </form>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length + 1" class="sdps-text-center"
          [innerHTML]="getEmtrConstants.rulesConstant.autoComplete.noRecords"></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-indSec let-columns="columns" let-rowIndex="rowIndex">
      <tr *ngIf="rowIndex < pageObject.pageSize">
        <td class="table-checkbox-selection filter-icon"></td>
        <ng-container *ngFor="let col of columns">
          <td *ngIf="col.field !== 'actions'">
            <span *ngIf="col.field === 'name'">{{indSec[col.field] | titlecase}}</span>
            <span *ngIf="col.field !== 'name'">{{indSec[col.field]}}</span>
          </td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
  <p-paginator *ngIf="selectedSecurities && selectedSecurities.length > 0" class="common-pagination"
    [rows]="pageObject.pageSize"
    [alwaysShow]="(paginationCount && paginationCount > getSharedConstant.defaultTableRecords ? true : false)"
    [totalRecords]="paginationCount !== 0 ? paginationCount : selectedSecurities.length "
    (onPageChange)="paginate($event)" #p>
  </p-paginator>
</ems-accordion>
  <!-- Display ngOMS Group Info -->
     <ems-accordion *ngIf="showIGAssignPanel"  label={{getSharedConstant.ngOMS.groupInfo}}>
      <div class="">
      <div class="sdps-grid-container sdps-wrap">
        <div class="sdps-row">
          <div class="col-3">
            <div class="sdps-p-vertical_small">
              <strong>{{getSharedConstant.ngOMS.groupId}}</strong>
            </div>
            <div class="sdps-grid-container sdps-m-around_none">
              {{reviewInstGroupData?.ngOMSSecurityGroupsInfo?.groupId}}
            </div>
          </div>
          <div class="col-3">
            <div class="sdps-p-vertical_small">
              <strong>{{getSharedConstant.ngOMS.lastSyncStatus}}</strong>
            </div>
            <div class="sdps-grid-container sdps-m-around_none">
              {{reviewInstGroupData?.ngOMSSecurityGroupsInfo?.lastSyncStatus | uppercase}}
            </div>
          </div>
        </div>
        <div class="sdps-row">
          <div class="col-3">
            <div class="sdps-p-vertical_small">
              <strong>{{getSharedConstant.ngOMS.syncStartDate}}</strong>
            </div>
            <div class="sdps-grid-container sdps-m-around_none">
              {{reviewInstGroupData?.ngOMSSecurityGroupsInfo?.syncStartDate}}
            </div>
          </div>
          <div class="col-3">
            <div class="sdps-p-vertical_small">
              <strong>{{getSharedConstant.ngOMS.lastSyncDate}}</strong>
            </div>
            <div class="sdps-grid-container sdps-m-around_none">
              {{reviewInstGroupData?.ngOMSSecurityGroupsInfo?.lastSyncDate}}
            </div>
          </div>
        </div>
        <div class="sdps-row">
          <div class="col-3">
            <div class="sdps-p-vertical_small">
              <strong>{{getSharedConstant.ngOMS.reqCorrelationId}}</strong>
            </div>
            <div class="sdps-grid-container sdps-m-around_none">
              {{reviewInstGroupData?.ngOMSSecurityGroupsInfo?.reqCorrelationId}}
            </div>
          </div>
        </div>
      </div>
      </div>
     </ems-accordion>
<ems-step-wizard-buttons [showPreviousBtn]="showActionItems" (goToPrevious)="goToPreviousStep('../step2')"
                         [showCancelBtn]="showActionItems" (closeBtn)="cancelInstGroup()"
                         [showRevertBtn]="showActionItems"
                         [revertDisable]="revertDisable" (revert)="revertChanges()"
                         [showCloseBtn]="!showActionItems"
                         [disableBtn]="reviewInstrumentGrpForm?(reviewInstrumentGrpForm.invalid || groupNameExists || (reviewInstrumentGrpForm.get('groupName').value && reviewInstrumentGrpForm.get('groupName').value.trim().length === 0)):''"

    (downloadNgomsRuleAndForceSyncUp)="downloadNgomsRuleAndForceSyncUp($event)"
    [ngomsSyncStatusInfoButtons]="(ngOMSForceSync || downLoadNGOMSIG)"
  [ngOMSForceSync]="ngOMSForceSync" [downLoadNGOMSRule]="downLoadNGOMSIG"
  [forceSyncDisableBtn] = "forceSyncDisableBtn"
  [downloadDisableBtn] = "disableDownloadButton" [ngOmsDownloadBtnLabel]="getSharedConstant.ngOMS.ngOmsGroupDownloadBtnLabel"
  [showSaveBtn]="showActionItems" (save)="saveGroup()"></ems-step-wizard-buttons>
